var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/AdvertisingBanner/AdvertisingBanner.jinja"] = require( "front/components/AdvertisingBanner/AdvertisingBanner.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/AdvertisingBanner/AdvertisingBanner.jinja", false, "assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "AdvertisingBanner")) {
var t_7 = t_4.AdvertisingBanner;
} else {
cb(new Error("cannot import 'AdvertisingBanner'")); return;
}
context.setVariable("AdvertisingBanner", t_7);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_ADGAWARDS_1")) {
var t_8 = t_4.ADVERTISING_ADGAWARDS_1;
} else {
cb(new Error("cannot import 'ADVERTISING_ADGAWARDS_1'")); return;
}
context.setVariable("ADVERTISING_ADGAWARDS_1", t_8);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_ADGAWARDS_2")) {
var t_9 = t_4.ADVERTISING_ADGAWARDS_2;
} else {
cb(new Error("cannot import 'ADVERTISING_ADGAWARDS_2'")); return;
}
context.setVariable("ADVERTISING_ADGAWARDS_2", t_9);
output += "\n\n\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja", false, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
if(Object.prototype.hasOwnProperty.call(t_10, "SITE_SUBMISSIONS")) {
var t_13 = t_10.SITE_SUBMISSIONS;
} else {
cb(new Error("cannot import 'SITE_SUBMISSIONS'")); return;
}
context.setVariable("SITE_SUBMISSIONS", t_13);
output += "\n\n\n";
var macro_t_14 = runtime.makeMacro(
["item", "title", "subtitle"], 
["eligible", "release", "eligibleUrl", "withTime"], 
function (l_item, l_title, l_subtitle, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("item", l_item);
frame.set("title", l_title);
frame.set("subtitle", l_subtitle);
frame.set("eligible", Object.prototype.hasOwnProperty.call(kwargs, "eligible") ? kwargs["eligible"] : runtime.contextOrFrameLookup(context, frame, "None"));frame.set("release", Object.prototype.hasOwnProperty.call(kwargs, "release") ? kwargs["release"] : runtime.contextOrFrameLookup(context, frame, "None"));frame.set("eligibleUrl", Object.prototype.hasOwnProperty.call(kwargs, "eligibleUrl") ? kwargs["eligibleUrl"] : "");frame.set("withTime", Object.prototype.hasOwnProperty.call(kwargs, "withTime") ? kwargs["withTime"] : runtime.contextOrFrameLookup(context, frame, "False"));var t_15 = "";t_15 += "\n    <li class=\"AwardsADGContent-sheduleListItem\">\n        <div class=\"AwardsADGContent-sheduleListItemDate\">\n            ";
if(l_item && runtime.memberLookup((l_item),"date")) {
t_15 += "<div class=\"AwardsADGContent-sheduleListItemDay\">";
t_15 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((l_item),"date"),"%d"), env.opts.autoescape);
t_15 += "</div>\n                <div class=\"AwardsADGContent-sheduleListItemMonth\">";
t_15 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((l_item),"date"),"%b"), env.opts.autoescape);
t_15 += "</div>\n            ";
;
}
else {
t_15 += "<div class=\"AwardsADGContent-sheduleListItemTBD\">TBD</div>\n            ";
;
}
t_15 += "</div>\n        <div class=\"AwardsADGContent-sheduleListItemTitle\">";
t_15 += runtime.suppressValue(l_title, env.opts.autoescape);
t_15 += "</div>\n        <div class=\"AwardsADGContent-sheduleListItemDetails\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "withTime") && !env.getFilter("is_none").call(context, runtime.memberLookup((l_item),"time"))) {
t_15 += "\n                    <strong>";
t_15 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((l_item),"date"),"%I:%M"), env.opts.autoescape);
t_15 += runtime.suppressValue(env.getFilter("datetimeNoZeroPadding").call(context, runtime.memberLookup((l_item),"date"),"%p"), env.opts.autoescape);
t_15 += " PST </strong>\n                ";
;
}
t_15 += runtime.suppressValue(l_subtitle, env.opts.autoescape);
t_15 += "\n        </div>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "eligible")) {
t_15 += "<div class=\"AwardsADGContent-sheduleListItemEligible\">\n                <a href=\"";
t_15 += runtime.suppressValue((lineno = 27, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, [runtime.contextOrFrameLookup(context, frame, "eligibleUrl"),runtime.makeKeywordArgs({"args": [runtime.contextOrFrameLookup(context, frame, "eligible")]})])), env.opts.autoescape);
t_15 += "\">Eligible Projects</a>\n            </div>\n        ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "release")) {
t_15 += "<div class=\"AwardsADGContent-sheduleListItemPressRelease\">\n                <a href=\"";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "release"), env.opts.autoescape);
t_15 += "\" target=\"_blank\">Press Release</a>\n            </div>\n        ";
;
}
t_15 += "\n    </li>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_15);
});
context.addExport("ScheduleItem");
context.setVariable("ScheduleItem", macro_t_14);
output += "\n\n\n";
var macro_t_16 = runtime.makeMacro(
[], 
["data", "showPromo", "eligibleUrl"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("showPromo", Object.prototype.hasOwnProperty.call(kwargs, "showPromo") ? kwargs["showPromo"] : true);frame.set("eligibleUrl", Object.prototype.hasOwnProperty.call(kwargs, "eligibleUrl") ? kwargs["eligibleUrl"] : "");var t_17 = "";t_17 += "\n\n<div class=\"AwardsADGContent\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "showPromo")) {
t_17 += "<div class=\"AwardsADGContent-members\">\n        <h2>The annual ADG Awards</h2>\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")) {
t_17 += "<a href=\"";
t_17 += runtime.suppressValue((lineno = 47, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg_winners-popup",runtime.makeKeywordArgs({"args": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")),"typ"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")),"year")]})])), env.opts.autoescape);
t_17 += "\" class=\"AwardsADGContent-membersItem\">\n            <div class=\"AwardsADGContent-membersItemImg\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                <img src=\"";
t_17 += runtime.suppressValue((lineno = 49, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADG/winners.jpg"])), env.opts.autoescape);
t_17 += "\"\n                    srcset=\"";
t_17 += runtime.suppressValue((lineno = 50, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADG/winners.jpg"])), env.opts.autoescape);
t_17 += " 2x\"\n                    alt=\"\">\n            </div>\n            <h3>";
t_17 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"winners_year")),"caption"), env.opts.autoescape);
t_17 += "</h3>\n            <div class=\"AwardsADGContent-membersItemText\"><p>Outstanding members in production design within television and film.</p></div>\n            <div class=\"AwardsADGContent-membersItemArrow\">\n                ";
t_17 += runtime.suppressValue((lineno = 56, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_18 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_19 = "";;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
return macro_t_18;})()})])), env.opts.autoescape);
t_17 += "\n            </div>\n        </a>\n        ";
;
}
t_17 += "<a href=\"";
t_17 += runtime.suppressValue((lineno = 61, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg_ceremony-popup"])), env.opts.autoescape);
t_17 += "\" class=\"AwardsADGContent-membersItem\">\n            <div class=\"AwardsADGContent-membersItemImg\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                <img src=\"";
t_17 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_preview_cover")),"w440_url"), env.opts.autoescape);
t_17 += "\"\n                    srcset=\"";
t_17 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_preview_cover")),"w680_url"), env.opts.autoescape);
t_17 += " 2x\"\n                    alt=\"\">\n            </div>\n            <h3>The Ceremony</h3>\n            <div class=\"AwardsADGContent-membersItemText\">";
t_17 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_preview_content_rendered")), env.opts.autoescape);
t_17 += "</div>\n            <div class=\"AwardsADGContent-membersItemArrow\">\n                ";
t_17 += runtime.suppressValue((lineno = 70, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_17 += "\n            </div>\n        </a>\n    </div>\n    ";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_1")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_1")))) {
t_17 += "\n        <div class=\"AwardsADGContent-advertisingBannerWrapper AwardsADGContent-advertisingBannerWrapper--position-1\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            ";
t_17 += runtime.suppressValue((lineno = 78, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AdvertisingBanner"), "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_1")),"size": "billboard","position": "ADG AWARDS – POSITION 1"})])), env.opts.autoescape);
t_17 += "\n        </div>\n    ";
;
}
t_17 += "\n\n    <div class=\"AwardsADGContent-shedule\">\n        <h2>Submissions</h2>\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"overview_rendered") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"pdf")) {
t_17 += "\n            <div class=\"AwardsADGContent-sheduleRules\">\n                <div class=\"AwardsADGContent-sheduleRulesText\">";
t_17 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"overview_rendered")), env.opts.autoescape);
t_17 += "</div>\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"pdf")) {
t_17 += "<a href=\"";
t_17 += runtime.suppressValue((lineno = 89, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"pdf")),"url"), "data[\"page\"][\"pdf\"][\"url\"]", context, [])), env.opts.autoescape);
t_17 += "\" class=\"AwardsADGContent-sheduleRulesButton\">Rules & Specifications</a>\n                ";
;
}
t_17 += "</div>\n        ";
;
}
t_17 += "\n\n        <ul class=\"AwardsADGContent-sheduleList\">\n            ";
t_17 += runtime.suppressValue((lineno = 95, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"so"),"SUBMISSIONS OPEN","FOR TELEVISION & FEATURE FILM",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 96, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"tv_sc"),"TELEVISION SUBMISSIONS CLOSE","FEATURE FILM SUBMISSIONS REMAIN OPEN",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 97, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"tv_sr"),"TELEVISION SUBMISSIONS REVIEW","BY THE AWARDS COMMITTEE",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 98, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"tv_ep"),"ELIGIBLE TELEVISION PROJECTS POSTED","UPLOADED ASSETS & PRESENTATIONS VISIBLE (ROLLING)",runtime.makeKeywordArgs({"eligible": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"eligible")),"tv"),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 99, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"film_ep"),"ELIGIBLE FEATURE FILM PROJECTS POSTED","UPLOADED ASSETS & PRESENTATIONS VISIBLE (ROLLING)",runtime.makeKeywordArgs({"eligible": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"eligible")),"film"),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 100, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"submissions")),"uc"),"FEATURE FILM SUBMISSIONS CLOSE","UPLOADED ASSETS & PRESENTATIONS VISIBLE (ROLLING)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n        </ul>\n\n        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"submitButton"))) {
t_17 += "\n            <a class=\"AwardsADGContent-sheduleListSubmit\" href=\"";
t_17 += runtime.suppressValue((lineno = 104, colno = 75, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [runtime.contextOrFrameLookup(context, frame, "SITE_SUBMISSIONS"),"submissions"])), env.opts.autoescape);
t_17 += "\">Submit a Project</a>\n        ";
;
}
t_17 += "\n    </div>\n\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_2")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_2")))) {
t_17 += "\n        <div class=\"AwardsADGContent-advertisingBannerWrapper AwardsADGContent-advertisingBannerWrapper--position-2\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            ";
t_17 += runtime.suppressValue((lineno = 111, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AdvertisingBanner"), "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_ADGAWARDS_2")),"size": "leaderboard","position": "ADG AWARDS – POSITION 2"})])), env.opts.autoescape);
t_17 += "\n        </div>\n    ";
;
}
t_17 += "\n\n    <div class=\"AwardsADGContent-shedule\">\n        <h2>Voting</h2>\n        <ul class=\"AwardsADGContent-sheduleList\">\n            ";
t_17 += runtime.suppressValue((lineno = 118, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"nvb"),"NOMINATION VOTING BEGINS","FOR TELEVISION & FEATURE FILM PROJECTS (ART DIRECTORS ONLY)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 119, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"nve"),"NOMINATION VOTING ENDS","FOR TELEVISION & FEATURE FILM PROJECTS (ART DIRECTORS ONLY)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl"),"withTime": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 120, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"na"),"NOMINATIONS ANNOUNCED","BY THE AWARDS COMMITTEE",runtime.makeKeywordArgs({"release": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"nominations_release_visible") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"nominations_release") && (lineno = 120, colno = 220, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"nominations_release")),"url"), "data[\"page\"][\"nominations_release\"][\"url\"]", context, [])),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 121, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"fvb"),"FINAL VOTING BEGINS","FOR FINAL BALLOTS (ALL CRAFTS)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n            ";
t_17 += runtime.suppressValue((lineno = 122, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"voting")),"fve"),"FINAL VOTING ENDS","FOR FINAL BALLOTS (ALL CRAFTS)",runtime.makeKeywordArgs({"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl"),"withTime": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_17 += "\n        </ul>\n    </div>\n\n\n    <div class=\"AwardsADGContent-shedule\">\n        <h2>Award ceremony</h2>\n        <ul class=\"AwardsADGContent-sheduleList\">\n            ";
t_17 += runtime.suppressValue((lineno = 130, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ScheduleItem"), "ScheduleItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"schedule")),"gala")),"aag"),"THE ANNUAL AWARDS GALA\nWINNERS ANNOUNCED","See Press Release section for more information",runtime.makeKeywordArgs({"release": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_release_visible") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_release") && (lineno = 130, colno = 241, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"show_release")),"url"), "data[\"page\"][\"show_release\"][\"url\"]", context, [])),"eligibleUrl": runtime.contextOrFrameLookup(context, frame, "eligibleUrl")})])), env.opts.autoescape);
t_17 += "\n        </ul>\n    </div>\n\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories"))) {
t_17 += "\n        <div class=\"AwardsADGContent-rules\">\n            <h2>AWARD CATEGORIES</h2>\n\n            ";
frame = frame.push();
var t_24 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_24) {t_24 = runtime.fromIterator(t_24);
var t_23 = t_24.length;
for(var t_22=0; t_22 < t_24.length; t_22++) {
var t_25 = t_24[t_22];
frame.set("category", t_25);
frame.set("loop.index", t_22 + 1);
frame.set("loop.index0", t_22);
frame.set("loop.revindex", t_23 - t_22);
frame.set("loop.revindex0", t_23 - t_22 - 1);
frame.set("loop.first", t_22 === 0);
frame.set("loop.last", t_22 === t_23 - 1);
frame.set("loop.length", t_23);
t_17 += "<div class=\"AwardsADGContent-rulesCategories\">\n                <h3>";
t_17 += runtime.suppressValue(runtime.memberLookup((t_25),"title"), env.opts.autoescape);
t_17 += "</h3>\n                <ul class=\"AwardsADGContent-rulesCategoriesList\">\n                ";
frame = frame.push();
var t_28 = runtime.memberLookup((t_25),"list");
if(t_28) {t_28 = runtime.fromIterator(t_28);
var t_27 = t_28.length;
for(var t_26=0; t_26 < t_28.length; t_26++) {
var t_29 = t_28[t_26];
frame.set("item", t_29);
frame.set("loop.index", t_26 + 1);
frame.set("loop.index0", t_26);
frame.set("loop.revindex", t_27 - t_26);
frame.set("loop.revindex0", t_27 - t_26 - 1);
frame.set("loop.first", t_26 === 0);
frame.set("loop.last", t_26 === t_27 - 1);
frame.set("loop.length", t_27);
t_17 += "<li class=\"AwardsADGContent-rulesCategoriesListItem\">\n                        <div class=\"AwardsADGContent-rulesCategoriesListItemCategory\">";
t_17 += runtime.suppressValue(runtime.memberLookup((t_29),"category"), env.opts.autoescape);
t_17 += "</div>\n                        <div class=\"AwardsADGContent-rulesCategoriesListItemTitle\">\n                            <div class=\"AwardsADGContent-rulesCategoriesListItemTable\">\n                                <div class=\"AwardsADGContent-rulesCategoriesListItemCell\">";
t_17 += runtime.suppressValue(runtime.memberLookup((t_29),"title"), env.opts.autoescape);
t_17 += "</div>\n                            </div>\n                        </div>\n                        ";
if(runtime.memberLookup((t_29),"new")) {
t_17 += "\n                            <div class=\"AwardsADGContent-rulesCategoriesListItemLabel\">new</div>\n                        ";
;
}
t_17 += "\n                    </li>\n                ";
;
}
}
frame = frame.pop();
t_17 += "\n                </ul>\n            </div>\n            ";
;
}
}
frame = frame.pop();
t_17 += "</div>\n    ";
;
}
t_17 += "\n\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts"))) {
t_17 += "\n        <div class=\"AwardsADGContent-crafts\">\n            <h2>Recognized crafts</h2>\n\n            <div class=\"AwardsADGContent-craftsWrapper\">\n                ";
frame = frame.push();
var t_32 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"crafts");
if(t_32) {t_32 = runtime.fromIterator(t_32);
var t_31 = t_32.length;
for(var t_30=0; t_30 < t_32.length; t_30++) {
var t_33 = t_32[t_30];
frame.set("craft", t_33);
frame.set("loop.index", t_30 + 1);
frame.set("loop.index0", t_30);
frame.set("loop.revindex", t_31 - t_30);
frame.set("loop.revindex0", t_31 - t_30 - 1);
frame.set("loop.first", t_30 === 0);
frame.set("loop.last", t_30 === t_31 - 1);
frame.set("loop.length", t_31);
t_17 += "<div class=\"AwardsADGContent-craftsColumn\">\n                        <h3>";
t_17 += runtime.suppressValue((lineno = 170, colno = 50, runtime.callWrap(runtime.memberLookup((t_33),"get_kind_display"), "craft[\"get_kind_display\"]", context, [])), env.opts.autoescape);
t_17 += " Craft</h3>\n                        <div>";
t_17 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_33),"content_rendered")), env.opts.autoescape);
t_17 += "</div>\n                    </div>\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 3 == 0) {
t_17 += "<div class=\"AwardsADGContent-craftsColumnSeparator\"></div>\n                    ";
;
}
;
}
}
frame = frame.pop();
t_17 += "</div>\n        </div>\n    ";
;
}
t_17 += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"downloads") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"downloads"))) {
t_17 += "\n        <div class=\"AwardsADGContent-downloads\">\n            <h2>Downloads</h2>\n            <ul class=\"AwardsADGContent-downloadsList\">\n                ";
frame = frame.push();
var t_36 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"release")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"downloads"):"");
if(t_36) {t_36 = runtime.fromIterator(t_36);
var t_35 = t_36.length;
for(var t_34=0; t_34 < t_36.length; t_34++) {
var t_37 = t_36[t_34];
frame.set("item", t_37);
frame.set("loop.index", t_34 + 1);
frame.set("loop.index0", t_34);
frame.set("loop.revindex", t_35 - t_34);
frame.set("loop.revindex0", t_35 - t_34 - 1);
frame.set("loop.first", t_34 === 0);
frame.set("loop.last", t_34 === t_35 - 1);
frame.set("loop.length", t_35);
t_17 += "<li class=\"AwardsADGContent-downloadsListItem\">\n                        <a class=\"AwardsADGContent-downloadsListItemLink\" href=\"";
t_17 += runtime.suppressValue((lineno = 187, colno = 96, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((t_37),"release")),"url"), "item[\"release\"][\"url\"]", context, [])), env.opts.autoescape);
t_17 += "\">\n                        <div class=\"AwardsADGContent-downloadsListItemTitle\">";
t_17 += runtime.suppressValue(runtime.memberLookup((t_37),"title"), env.opts.autoescape);
t_17 += "</div>\n                        <div class=\"AwardsADGContent-downloadsListItemArrow\">\n                            ";
t_17 += runtime.suppressValue((lineno = 190, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_38 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_39 = "";;
frame = frame.pop();
return new runtime.SafeString(t_39);
});
return macro_t_38;})()})])), env.opts.autoescape);
t_17 += "\n                        </div>\n                        </a>\n                    </li>\n                ";
;
}
}
frame = frame.pop();
t_17 += "\n            </ul>\n        </div>\n    ";
;
}
t_17 += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sponsors") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sponsors"))) {
t_17 += "\n        <div class=\"AwardsADGContent-sponsors\">\n            <h2>Media Sponsors</h2>\n            <div class=\"AwardsADGContent-sponsorsColumns\">\n                <div class=\"AwardsADGContent-sponsorsLeftColumn\">";
t_17 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"page")),"media_rendered")), env.opts.autoescape);
t_17 += "</div>\n                <div class=\"AwardsADGContent-sponsorsRightColumn\">\n                    ";
frame = frame.push();
var t_42 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sponsors");
if(t_42) {t_42 = runtime.fromIterator(t_42);
var t_41 = t_42.length;
for(var t_40=0; t_40 < t_42.length; t_40++) {
var t_43 = t_42[t_40];
frame.set("item", t_43);
frame.set("loop.index", t_40 + 1);
frame.set("loop.index0", t_40);
frame.set("loop.revindex", t_41 - t_40);
frame.set("loop.revindex0", t_41 - t_40 - 1);
frame.set("loop.first", t_40 === 0);
frame.set("loop.last", t_40 === t_41 - 1);
frame.set("loop.length", t_41);
t_17 += "<div class=\"AwardsADGContent-sponsorsRightColumnImage\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_17 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") * 100, env.opts.autoescape);
t_17 += "\">\n                            <img src=\"";
t_17 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_43),"img")),"w500_url"), env.opts.autoescape);
t_17 += "\" alt=\"\">\n                        </div>\n                    ";
;
}
}
frame = frame.pop();
t_17 += "\n                </div>\n            </div>\n        </div>\n    ";
;
}
t_17 += "\n</div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_17);
});
context.addExport("AwardsADGContent");
context.setVariable("AwardsADGContent", macro_t_16);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsADGContent/AwardsADGContent.jinja
// module id = 211
// module chunks = 0